import { render, staticRenderFns } from "./TwoAudioBar.vue?vue&type=template&id=667dcafa&scoped=true&"
import script from "./TwoAudioBar.vue?vue&type=script&lang=js&"
export * from "./TwoAudioBar.vue?vue&type=script&lang=js&"
import style0 from "./TwoAudioBar.vue?vue&type=style&index=0&id=667dcafa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667dcafa",
  null
  
)

export default component.exports